import { SupportedChainId } from '~/constants/chains'
import { IAddress } from '~/types'

export const getTokenMetadataLookupKey = (
  chainId: SupportedChainId,
  address: IAddress,
) => `${chainId}:${address.toLowerCase()}`
